import React from "react"

import { hasSchemaType } from "shared/lib/json-schema/hasSchemaType"
import { RJSFSchema } from "shared/types/RJSF"

import { RJSFFormBooleanField } from "./RJSFFormBooleanField"
import { RJSFFormNumberField } from "./RJSFFormNumberField"
import { RJSFFormObjectField } from "./RJSFFormObjectField"
import { RJSFFormStringField } from "./RJSFFormStringField"
import { RJSFFormFieldProps } from "./types"

interface RJSFFormFieldFactoryProps {
  path: string
  schema: RJSFSchema
  isDisabled?: boolean

  FieldInformationRenderer?: React.ComponentType<RJSFFormFieldProps>
}

export const RJSFFormFieldFactory = React.memo(
  ({ schema, ...rest }: RJSFFormFieldFactoryProps) => {
    if (schema.isHidden) {
      return null
    }

    if (hasSchemaType(schema, "string")) {
      return <RJSFFormStringField schema={schema} {...rest} />
    }
    if (hasSchemaType(schema, ["number", "integer"])) {
      return <RJSFFormNumberField schema={schema} {...rest} />
    }
    if (hasSchemaType(schema, "boolean")) {
      return <RJSFFormBooleanField schema={schema} {...rest} />
    }
    if (hasSchemaType(schema, "object") || schema.type === undefined) {
      return <RJSFFormObjectField schema={schema} {...rest} />
    }

    return null
  }
)
